/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

export const FACT_NAME_LABEL_MAP: Record<
  string,
  { label: string; idLabel: string }
> = {
  default: {
    label: 'Traces',
    idLabel: 'Trace ID',
  },
  conversations: {
    label: 'Conversations',
    idLabel: 'Conversation ID',
  },
  traces: {
    label: 'Traces',
    idLabel: 'Trace ID',
  },
  inferences: {
    label: 'Inferences',
    idLabel: 'Inference ID',
  },
  http: {
    label: 'Web Requests',
    idLabel: 'Web Request ID',
  },
  agent_requests: {
    label: 'Agentic Turns',
    idLabel: 'Agentic Turn ID',
  },
  agent_operations: {
    label: 'Agent Invocations',
    idLabel: 'Agent Invocation ID',
  },
  tool_operations: {
    label: 'Tool Executions',
    idLabel: 'Tool Execution ID',
  },
  agent_sessions: {
    label: 'Agent Sessions',
    idLabel: 'Agent Session ID',
  },
  git_commits: {
    label: 'Commits',
    idLabel: 'Commit ID',
  },
  test_runs: {
    label: 'Test Runs',
    idLabel: 'Test Run ID',
  },
  tests: {
    label: 'Tests',
    idLabel: 'Test ID',
  },
  mcp_invocations: {
    label: 'MCP Invocations',
    idLabel: 'MCP Invocation ID',
  },
  tenants: {
    label: 'Tenants',
    idLabel: 'Tenant ID',
  },
};
